import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ButtonLoader, FormsUtilsService, MessageService } from '../../../../../core';
import { ClienteFilter } from '../../filter';
import { ClienteContatoExcelHttpService } from '../services';
import { ClienteContatoExcelExportModal } from './cliente-contato-excel-export-modal';


@Component({
    selector: 'sgt-cliente-contato-excel-export-modal',
    templateUrl: './cliente-contato-excel-export-modal.component.html',
    styleUrls: ['./cliente-contato-excel-export-modal.component.less']
})
export class ClienteContatoExcelExportModalComponent implements OnInit {
    elModal: any;
    @ViewChild('form') form: NgForm;
    entityModal: ClienteContatoExcelExportModal;

    constructor(private el: ElementRef,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private clienteContatoExcelHttpService: ClienteContatoExcelHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#nomeExportacao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(filter: ClienteFilter,) {
        this.entityModal = new ClienteContatoExcelExportModal(filter);
        this.elModal.modal({keyboard: false});
    }

    private clear() {
        this.entityModal = null;
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Valida os dados para realizar a exportação */
    private validateExport(): boolean {
        // Nenhum dado
        if (!this.entityModal) {
            this.messageService.info('Não foi possível realizar a exportação por que nenhum dado de exportação foi criado. Tente fechar a janela e abrir novamente.', 'Informação');
            return false;
        }

        // Sem nome da exportação
        if (!this.entityModal.nomeExportacao) {
            this.messageService.info('Informe o nome da exportação para poder exportar', 'Informação');
            jQuery(this.elModal).find('#nomeExportacao').trigger('focus');
            return false;
        }

        // Form inválido
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false;
        }

        return true;
    }

   /** Realiza a exportação da pesquisa dos contato dos clientes */
    export() {
        if (!this.validateExport()) {
            return false;
        }

        const btn = new ButtonLoader('#btnClienteContatoExcelExport');
        btn.loading('Exportando');
        this.clienteContatoExcelHttpService.export(this.entityModal.filter, this.entityModal.nomeExportacao)
            .then(() => {
                btn.reset();
                this.close();
            })
            .catch(() => {
                this.messageService.error('Ocorreu um erro ao exportar a pesquisa dos contatos do cliente para Excel. Tente novamente', 'Erro ao exportar');
                btn.reset();
            });
    }
}
